import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNetwork } from '../contexts/NetworkContext';
// Embedded data URI — renders even with ZERO network.
import { WASSLA_W_LOGO as wLogo } from '../assets/wasslaLogoData';
import './OfflineScreen.css';

/**
 * OfflineScreen — iter353 full-screen offline state.
 *
 * Shows the official Wassla W logo centered on a clean white screen
 * whenever the device loses its connection (after a short grace period
 * so brief blips don't flash the screen). Auto-dismisses on reconnect.
 * Per spec: logo only + short message — no buttons, no decoration,
 * no glow, no animation.
 */
const GRACE_MS = 2000;

export default function OfflineScreen() {
  const { isOnline } = useNetwork();
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);

  const isArabic = i18n.language?.startsWith('ar');

  useEffect(() => {
    if (isOnline) {
      setShow(false);
      return undefined;
    }
    const id = setTimeout(() => setShow(true), GRACE_MS);
    return () => clearTimeout(id);
  }, [isOnline]);

  if (!show) return null;

  return (
    <div
      className="offline-screen"
      dir={isArabic ? 'rtl' : 'ltr'}
      data-testid="offline-screen"
      role="status"
    >
      <img
        src={wLogo}
        alt="Wassla"
        className="offline-screen__logo"
        draggable={false}
      />
      <p className="offline-screen__text">
        {t('network.offlineScreenText', isArabic ? 'أنت غير متصل بالإنترنت' : "You're offline")}
      </p>
    </div>
  );
}
